import { useEffect, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  useGlobalReducer,
  useGlobalState,
} from "../../GlobalContext";
import { AnglesLeft, AnglesRight } from "../Icons";
import Navigation from "./Navigation";
import {
  getCurrentPageInfo,
  getNavigationItemsToShow,
} from "./Helpers";
import Logo from "../../svg/logo";
import GlobalDispatchMethods from "../../js/globalDispatchMethods";

function SideBar() {
  const globalDispatch = useGlobalReducer();
  const globalState = useGlobalState();

  const { initialStateBound, resetSitemap, showNavigation } =
    globalState;

  const [initialDisplaySet, setInitialDisplaySet] = useState(true);
  const [display, setDisplay] = useState("");
  const [subDisplay, setSubDisplay] = useState("");
  const [navigationItems, setNavigationItems] = useState([]);

  useEffect(() => {
    const setInitialDisplayPageValue = () => {
      const navItems = getNavigationItemsToShow(globalState);
      const page = getCurrentPageInfo(navItems);
      setNavigationItems(navItems);
      setDisplay(page.display);
      setSubDisplay(page.subDisplay);
      setInitialDisplaySet(false);
      if (resetSitemap) {
        globalDispatch({
          type: GlobalDispatchMethods.SitemapReset,
        });
      }
    };

    if (initialStateBound && (initialDisplaySet || resetSitemap)) {
      setInitialDisplayPageValue();
    }
  }, [
    globalDispatch,
    globalState,
    initialDisplaySet,
    initialStateBound,
    navigationItems,
    resetSitemap,
  ]);

  const toggleDisplay = (itemId) => {
    setDisplay(itemId === display ? "" : itemId);
  };

  const toggleSubDisplay = (itemId) => {
    setSubDisplay(itemId === subDisplay ? "" : itemId);
  };

  return (
    <nav
      id="sidebar"
      className={classNames(
        "navbar d-md-block",
        showNavigation ? "sidebar-expanded" : ""
      )}
    >
      {showNavigation && (
        <>
          <div id="logo">
            <Logo />
          </div>
          {initialStateBound && (
            <Navigation
              {...{
                display,
                navigationItems,
                subDisplay,
                toggleDisplay,
                toggleSubDisplay,
              }}
            />
          )}
        </>
      )}
      <div
        id="sidebar-collapse"
        onClick={() => {
          globalDispatch({
            type: GlobalDispatchMethods.ToggleNavigation,
          });
        }}
      >
        {showNavigation && <FontAwesomeIcon icon={AnglesLeft} />}
        {!showNavigation && <FontAwesomeIcon icon={AnglesRight} />}
      </div>
    </nav>
  );
}

export default SideBar;
